// Seller shell sidebar + Home strings — EN + TR.
//
// Wave-1 Day 2 wiring. Standard sidebar items + Personalize submenu (Wave 4)
// + BodyCard prose.
//
// Scope: only labels owned by SellerShell.tsx; Wallet/Workspace shared
// helper items left to their own dictionary (Wave-1 out-of-scope).

import type { LocalizedDict } from '../index'

type SellerShellStrings = {
  title: string
  items: {
    overview: string
    myOrders: string
    awaitingShipment: string
    awaitingPayment: string
    shipped: string
    onHold: string
    cancelled: string
    allOrders: string
    otherStoreOrders: (provider: string) => string
    returns: string
    catalogue: string
    productsGroup: string
    products: string
    listings: string
    inventory: string
    productReports: string
    storesGroup: string
    myStores: string
    scorecard: string
    reviews: string
    reportsGroup: string
    storePerformance: string
    activityHistory: string
    toolsGroup: string
    etsyProfitCalc: string
    etsyTrends: string
    usCalendar: string
    scenes: string
    servers: string
    walletGroup: string
    balance: string
    addFunds: string
    stripePayouts: string
    bankAccount: string
    referral: string
    subscription: string
    myFiles: string
    help: string
    settings: string
    workspace: string
  }
}

export const sellerShellI18n: LocalizedDict<SellerShellStrings> = {
  en: {
    title: 'Seller',
    items: {
      overview: 'Home',
      myOrders: 'My Orders',
      awaitingShipment: 'Awaiting Shipment',
      awaitingPayment: 'Awaiting Payment',
      shipped: 'Shipped',
      onHold: 'On Hold',
      cancelled: 'Cancelled',
      allOrders: 'All Orders',
      otherStoreOrders: (provider) => `Other ${provider} orders`,
      returns: 'Returns',
      catalogue: 'PEXIFY Catalogue',
      productsGroup: 'My Products',
      products: 'Products',
      listings: 'Listings',
      inventory: 'Inventory',
      productReports: 'Product reports',
      storesGroup: 'Stores',
      myStores: 'My stores',
      scorecard: 'Scorecard',
      reviews: 'Reviews',
      reportsGroup: 'Reports',
      storePerformance: 'Store performance',
      activityHistory: 'Activity history',
      toolsGroup: 'Tools',
      etsyProfitCalc: 'Etsy profit calculator',
      etsyTrends: 'Trends',
      usCalendar: 'US event calendar',
      scenes: 'Scene builder',
      servers: 'Servers',
      walletGroup: 'Wallet',
      balance: 'Balance and activity',
      addFunds: 'Add funds',
      stripePayouts: 'Stripe payouts',
      bankAccount: 'Bank account',
      referral: 'Invite and earn',
      subscription: 'Subscription',
      myFiles: 'My files',
      help: 'Help',
      settings: 'Settings',
      workspace: 'Workspace',
    },
  },
  tr: {
    title: 'Satıcı',
    items: {
      overview: 'Ana Sayfa',
      myOrders: 'Siparişlerim',
      awaitingShipment: 'Kargo Bekliyor',
      awaitingPayment: 'Ödeme Bekliyor',
      shipped: 'Kargoya Verildi',
      onHold: 'Beklemede',
      cancelled: 'İptal Edildi',
      allOrders: 'Tüm Siparişler',
      otherStoreOrders: (provider) => `Diğer ${provider} siparişleri`,
      returns: 'İadeler',
      catalogue: 'PEXIFY Kataloğu',
      productsGroup: 'Ürünlerim',
      products: 'Ürünler',
      listings: 'İlanlar',
      inventory: 'Stok',
      productReports: 'Ürün bildirimlerim',
      storesGroup: 'Mağazalar',
      myStores: 'Mağazalarım',
      scorecard: 'Mağaza Karnesi',
      reviews: 'Yorumlar',
      reportsGroup: 'Raporlar',
      storePerformance: 'Mağaza performansı',
      activityHistory: 'Hareket geçmişi',
      toolsGroup: 'Araçlar',
      etsyProfitCalc: 'Etsy kâr hesaplayıcı',
      etsyTrends: 'Trendler',
      usCalendar: 'ABD etkinlik takvimi',
      scenes: 'Sahne oluşturucu',
      servers: 'Sunucular',
      walletGroup: 'Cüzdan',
      balance: 'Bakiye ve hareketler',
      addFunds: 'Para yükle',
      stripePayouts: 'Stripe ile ödeme alma',
      bankAccount: 'Banka hesabı',
      referral: 'Davet et, kazan',
      subscription: 'Abonelik',
      myFiles: 'Dosyalarım',
      help: 'Yardım',
      settings: 'Ayarlar',
      workspace: 'Çalışma Alanı',
    },
  },
}
